import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListTable";
import { css } from "styled-components";

actionsStyles.availabilityCell = {
    css: css`
        > div {
            > div {
                > div {
                    > [data-test-selector="stockAvailabilityStatus"] {
                        flex-direction: column;
                        > div {
                            > [data-test-selector="stockAvailabilityMessage"] {
                                > [class^="IconWrapper"] {
                                    margin-bottom: 3px;
                                }
                            }
                        }
                    }
                }
            }
        }
    `,
};
